export { default } from "@/features/profile/screens/edit-profile";
